_LANGS = $('html').data('languages').split('|');
_LANG = $('html').attr('lang');
var _STR = {};

_STR['fr'] = {
	'Are you sure?' : 'Êtes-vous sûr ?',
	'Search' : 'Rechercher',
	'No result' : 'Aucun résultat'
};


function __str(str) {
	if( typeof _STR[_LANG][str] != 'undefined' )
		return _STR[_LANG][str];
	else
		return str;
}
window.__str = __str;


/*
 * bouton de sélection de language dans les formulaires
 */
$(document).on('click', '.lang_selector .btn', function() {
	$('.lang_selector .btn').removeClass('active');
	$('.lang_selector .btn[data-lang="' + $(this).data('lang') + '"]').addClass('active');
	$('.lang_toggle').addClass('d-none');
	$('.lang_toggle.lang_' + $(this).data('lang')).removeClass('d-none');
});

// initialisation des champs multilingue
if($('.lang_selector').get().length > 0) {
	//init
	$('.btn:eq(0)', $('.lang_selector:eq(0)')).click();
}
